import { render, staticRenderFns } from "./RessuprimentoManual.vue?vue&type=template&id=139f224c&scoped=true"
import script from "./RessuprimentoManual.vue?vue&type=script&lang=js"
export * from "./RessuprimentoManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f224c",
  null
  
)

export default component.exports